interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="flex items-center justify-center gap-2 flex-wrap">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className="h-9 px-3 flex items-center gap-1 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
            p === page
              ? "bg-primary-500 text-background-50 font-medium"
              : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className="h-9 px-3 flex items-center gap-1 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}